import React, {useEffect} from 'react'

import './StadePage.scss'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setDoor} from "../../store/actions";
import {DoorModel} from "../../Models/DoorModel";
import powered from '../../Assets/Icons/powered.svg'
import Error from "../../Components/Error/Error";
import {useError} from "../../hooks/useError";
import {useGetEvent} from "../../hooks/useGetEvent";
import coubertin from "../../Assets/Logos/coubertin.svg";
import ladefense from "../../Assets/Logos/ladefense.svg";
//import matmut from "../../Assets/Logos/matmut.svg";
import bordeaux from "../../Assets/Logos/bordeaux.png";
import mauroy from "../../Assets/Logos/losc.png";
import parcdesprinces from "../../Assets/Logos/parcdesprinces.svg";
import rolandGarros from "../../Assets/Logos/rolandGarros.svg";

const stadesImages = new Map<string, string>()
stadesImages.set('PDC', coubertin)
stadesImages.set('PDA', ladefense)
stadesImages.set('BMA', bordeaux)
stadesImages.set('LIL', mauroy)
stadesImages.set('PDP', parcdesprinces)
stadesImages.set('RGP', rolandGarros)

const StadePage: React.FC = ({}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {stadium} = useParams()
    const [searchParams,] = useSearchParams();
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => eventError.open(""), () => apiError.open(""))

    useEffect(() => {
        setTimeout(() => {
            getEvent(
                stadium,
                (doors: DoorModel[]) => {
                    const doorId = searchParams.get("door")
                    const pdvId = searchParams.get("pdv")
                    if(doorId) {
                        dispatch(setDoor(doors.find((d: DoorModel) => d.id.toString() === doorId)))
                        navigate(`/stands?stadium=${stadium}&doorId=${doorId}`)
                    } else if(pdvId) {
                        dispatch(setDoor(undefined))
                        navigate(`/menu?stadium=${stadium}&pdvId=${pdvId}`)
                    } else {
                        navigate(`/choixporte?stadium=${stadium}`)
                    }
                }
            )
        }, 2500)
    }, [])

    return (
        <>
            <div className="homePage">
                <img src={stadesImages.get(stadium ?? '')} className="homePage--logo"/>
                <img src={powered} className="homePage--powered"/>
            </div>
            <Error show={eventError.visible} title={"Aucun événement en cours, revenez bientôt!"} subTitle={"Pas d'événement, pas de commande ! Mais nous serons bientôt de retour."} />
            <Error show={apiError.visible} title={"Le service n’est pas disponible actuellement"} subTitle={"Veuillez vous rendre à un stand pour plus d’informations."} />
        </>
    )
}

export default StadePage;
